import { IDENTITY_VERIFICATION_REQUEST_STATUS_KEYS } from "../components/Constants"

export const isRequestCompleted = (status) => {
  return (status === IDENTITY_VERIFICATION_REQUEST_STATUS_KEYS.COMPLETED);
}